import { render, staticRenderFns } from "./declinar.vue?vue&type=template&id=5bdbf54c&scoped=true"
import script from "./declinar.vue?vue&type=script&lang=js"
export * from "./declinar.vue?vue&type=script&lang=js"
import style0 from "./declinar.vue?vue&type=style&index=0&id=5bdbf54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdbf54c",
  null
  
)

export default component.exports